import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Label } from 'semantic-ui-react'
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, PDFDownloadLink, Svg } from '@react-pdf/renderer';
import axios from 'axios';
import './style.css';
import {
  Card,
  Table,
  Button,
  Checkbox,
  Stack,
  Paper,
  Avatar,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  FormControl,
  TextField
} from '@mui/material';
import { Link } from 'react-router-dom';

export default function Update(props) {
	
	const navigate  = useNavigate();
	
	const [id, setId] = useState(localStorage.getItem('id'));	
	const [deviceId, setDeviceId] = useState('');
	const [subscriberId, setSubscriberId] = useState('');
		
	const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
	
	useEffect(() => {
		setId(localStorage.getItem('id'));
		setDeviceId(localStorage.getItem('deviceId'));
        setSubscriberId(localStorage.getItem('subscriberId'));	
	}, []);
			
	const postData = () => {		
		axios.put(SERVER_URL + `/shared_devices/${id}`,
			{
				"deviceId": deviceId,
				"subscriberId": subscriberId,
			}
			).then(() => {
            navigate('/dashboard/SharedDevices')
        })
	}
		
    return (
		<Container maxWidth="xl">
	    <Typography variant="subtitle2" noWrap>
			Update dijeljenog uređaja
		</Typography>
        <Card>
		  
		    <TableContainer sx={{ minWidth: 1000 }}>
			
              <Table>
			  
                <TableBody>
        
                <TableRow>					
					<TableCell component="th" scope="row" >
						<Label>Device</Label>
							<TextField
							required
							defaultValue=""
							value={deviceId}
							onChange={(e) => setDeviceId(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>

                    <TableCell component="th" scope="row" >
						<Label>Subscriber</Label>
							<TextField
							required
							defaultValue=""
							value={subscriberId}
							onChange={(e) => setSubscriberId(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>						
                </TableRow>

                <TableRow>
                    <TableCell component="th" scope="row" >
						<Button onClick={postData} type='submit'>Spasi</Button>
                     </TableCell>			
                </TableRow>
				
                </TableBody>
				
              </Table>
			  
            </TableContainer>
			
        </Card>
        </Container>
    )
}